import {
  MRT_ColumnDef,
  MRT_RowData,
  MRT_TableOptions,
} from "mantine-react-table"
import { Input, Output } from "../../../../@client/api"
import { PaginatedData } from "../../../../@client/Theasoft_ApiServer__Utils_Pagination"
import { PaginatedListRequest } from "../infinit-scrolling-list"
import { InfinitScrollingTable } from "."

type KeysOfType<T, U> = {
  [K in keyof T]: T[K] extends U ? K : never
}[keyof T]

type MinimalTableUrls = KeysOfType<Output, PaginatedData<unknown>>
type PropertiesNotInInterface<TRequest, TRequestInterface> = Omit<
  TRequest,
  keyof TRequestInterface
>

type ExclusiveProperties<TRequest, TRequestInterface> =
  PropertiesNotInInterface<TRequest, TRequestInterface>

interface Props<URL extends MinimalTableUrls, TData extends MRT_RowData> {
  url: URL
  columnDefinitions: MRT_ColumnDef<TData>[]
  partialInput: ExclusiveProperties<Input[URL], PaginatedListRequest>
  onClickRow?: (row: TData) => void
  tableOptions?: Partial<Omit<MRT_TableOptions<TData>, "data" | "columns">>
}

export function MinimalInfinitScrollingTable<
  URL extends MinimalTableUrls,
  TData extends MRT_RowData = Output[URL]["data"],
>({
  url,
  partialInput,
  columnDefinitions,
  onClickRow,
  tableOptions,
}: Props<URL, TData>) {
  const minimalTableOptions = React.useMemo<
    Omit<MRT_TableOptions<TData>, "data">
  >(
    () => ({
      ...tableOptions,
      columns: columnDefinitions,
      enableSorting: false,
      enableColumnActions: false,
      enableTopToolbar: false,
    }),
    []
  )

  return (
    <InfinitScrollingTable
      tableOptions={minimalTableOptions}
      onClickRow={onClickRow}
      url={url}
      partialInput={partialInput}
    />
  )
}
